
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWind5 as ObiWind5Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-5.js';
 
 
 

 
 export const ObiWind5 = createComponent({
   react: React,
   tagName: 'obi-wind-5',
   elementClass: ObiWind5Element,
   events: {
     
   }
  });
 
 